// src/components/About/AboutQuery.js
import { apolloClient } from "../../services/apolloclient";
import { gql } from "@apollo/client";

export const GET_ABOUT = gql`
  query MyQuery {
    homePage {
      imageContainers {
        contentItems {
          ... on ImageContainer {
            title
            imageOrientation
            imageAltText
            text
            image {
              urls
            }
            enabled
          }
        }
      }
    }
  }
`;

export async function fetchAbout() {
  const result = await apolloClient.query({
    query: GET_ABOUT,
    fetchPolicy: "network-only",
  });

  return result.data;
}
